import axios from "utils/axios";
import { routes } from "api/routes";

export const apiAnalyzePredictions = async (params) => {
  const { data } = await axios.post(routes.analyzePredictions, params);
  return data;
};

export const apiFetchPredictionsMultipleModels = async (formData) => {
  const { data } = await axios.post(
    routes.getPredictionsMultipleModels,
    formData
  );
  return data;
};

export const apiSearchBacktestStrategies = async (formData) => {
  const { data } = await axios.post(routes.searchBacktestStrategies, formData);
  return data;
};

export const apiGetSymbolRecommendations = async (
  symbol,
  startDate,
  endDate,
  returnDict = false
) => {
  const { data } = await axios.get(routes.getSymbolRecommendations, {
    params: { symbol, startDate, endDate, returnDict },
  });
  return data;
};

export const apiEvaluateBuySellPolarity = async (formData) => {
  const { data } = await axios.post(routes.evaluateBuySellPolarity, formData);
  return data;
};

export const apiGetOptionsData = async (symbol) => {
  const { data } = await axios.get(routes.getOptionsData, {
    params: { symbol },
  });
  return data;
};

// Server-side backtest -- computes the same day-by-day engine used by
// startBacktest (BacktestStrategy.js), optionally driving it minute-by-minute
// against candles_1m for intraday take profit / stop loss / trailing take
// profit. `signal` lets the caller abort a superseded request (settings
// change while a previous run is still in flight).
export const apiRunBacktest = async (formData, signal) => {
  const { data } = await axios.post(routes.runBacktest, formData, { signal });
  return data;
};
